import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfiguratorService } from '../configurator-service/configurator.service';

@Injectable({
    providedIn: 'root'
})
export class ThemeConfigureService {
    theamConfigurationSubject: Subject<any> = new Subject<void>();
    constructor(
        private readonly configuratorService: ConfiguratorService
    ) { }

 getConfigurationDetail() {
      this.configuratorService.getAppConfigurationDetail().subscribe((data: any) => {
          const item: any = data.data;
      let theamConfig  = {
            headerLogo: item?.businessConfig?.headerLogo || '../assets/image/logo.png',
            footerLogo: item?.businessConfig?.footerLogo || '../assets/image/logo2.png',
            faviconLogo: item?.businessConfig?.faviconLogo || '../favicon.png',
            title: item?.businessConfig?.title || 'Fintrax',
            primaryColor: item?.businessConfig?.primaryColor || '#0058e9',
            secondaryColor: item?.businessConfig?.secondaryColor || '#ffffff',
            supportContactEmail: item?.bankConfig?.supportContactEmail || 'support@example.com',
            supportContactNumber: item?.bankConfig?.supportContactNumber || '0000000000'
          }
          document.documentElement.style.setProperty('--primary', theamConfig.primaryColor);
          document.documentElement.style.setProperty('--secondary', theamConfig.secondaryColor);
          const favicon: any = document.querySelector('link[rel="icon"]');
          favicon.setAttribute('href', theamConfig.faviconLogo);
          document.title = theamConfig.title;
        });
      
      }
}
